module.exports = __webpack_public_path__ + "static/media/ic_student_leave.2294f884.png";